import React from 'react';
import PackageInfo from '../PackageInfo/PackageInfo';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {PACKAGE_KEYS} from '../../utils/constants';

const FamilyPackageUsageDetails = ({
  title = '',
  onClick = () => {},
  collectiveUsages = {},
  packageUsages = {},
  btnText = ''
}) => {

  const activeKeys = PACKAGE_KEYS.filter(key => packageUsages[key] && collectiveUsages[key]);
  const isScrollable = activeKeys.length > 2;

  return (
    <div className='family-package-usage-details-container'>
      <span className='title'>{title}</span>
      <div className='packages-info-container'>
        <div className='packages-info-content'>
          {activeKeys.map((key, index) => (
            <PackageInfo
              key={key}
              packageData={packageUsages[key]}
              collectiveUsage={collectiveUsages[key]?.[0]}
              isLastElement={index === activeKeys.length - 1}
            />
          ))}
        </div>
      </div>
      <div className={`bottom-btn-container ${isScrollable ? 'scrollable' : ''}`}>
        <BtnSubmit text={btnText} onclick={onClick} />
      </div>
    </div>
  );
};

export default FamilyPackageUsageDetails;
